import { spawn } from 'redux-saga/effects';

import systemStatusSagas from './systemStatus/systemStatusSagas';

export default function* supportSagas() {
	yield spawn(systemStatusSagas);
}
